module.exports = __webpack_public_path__ + "static/media/avatarLauren.3bb689ba.jpg";